// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgUnlockedIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M18 10h-1V7c0-2.76-2.24-5-5-5S7 4.24 7 7c0 .55.45 1 1 1s1-.45 1-1c0-1.65 1.35-3 3-3s3 1.35 3 3v3H6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2m-5 6.72V18c0 .55-.45 1-1 1s-1-.45-1-1v-1.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2c0 .74-.4 1.38-1 1.72" />
  </g>
);
export default SvgUnlockedIcon;
SvgUnlockedIcon.displayName = 'SvgUnlockedIcon';
